import { render, staticRenderFns } from "./Validar.vue?vue&type=template&id=f13374a0&scoped=true&"
import script from "./Validar.vue?vue&type=script&lang=ts&"
export * from "./Validar.vue?vue&type=script&lang=ts&"
import style0 from "./Validar.vue?vue&type=style&index=0&id=f13374a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13374a0",
  null
  
)

export default component.exports